exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".table {\n  table-layout: fixed;\n  width: 100%; }\n  .table .tr-head {\n    background: #1464f6;\n    color: white; }\n  .table .lines {\n    border-collapse: collapse;\n    border: 1px dotted gray; }\n  .table th,\n  .table td {\n    padding: 2px 5px; }\n    .table th select.select-table,\n    .table td select.select-table {\n      margin-top: 5px;\n      width: 80%; }\n    .table th.center,\n    .table td.center {\n      text-align: center; }\n    .table th.width-center,\n    .table td.width-center {\n      text-align: center;\n      width: 25%; }\n    .table th.width,\n    .table td.width {\n      width: 20%; }\n    .table th.normal,\n    .table td.normal {\n      padding: 2px 5px;\n      width: 30%; }\n  .table tr.height {\n    height: 30px; }\n\n.container-table {\n  max-height: 70vh;\n  overflow: auto; }\n\n.min-height {\n  min-height: 400px; }\n\nlabel.in {\n  display: inline; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/import-template/component/define-columns/define-columns.component.scss
// module id = 2028
// module chunks = 66